export enum ApplyAdvancedFiltersDialogAdditionalAction {
  NONE = 0,
  SAVE,
  SAVE_AS,
  DEACTIVATE
}
